import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConstantsService } from '../constants/constants.service';
import { inject } from '@angular/core';

export const AuthGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const constants = inject(ConstantsService);
  const router = inject(Router);

  const user = constants.getSession();

  // Not logged in → redirect to login
  if (!user) {
    return router.createUrlTree(['/login']);
  }

  const roleKey = user.role?.keyRole as string;

  // Define the home/default route for each role
  const homeRoutes: Record<string, string> = {
    HOST:      '/dashboard',
    ADMIN:     '/users',
    RECEPTION: '/todays-visits',
    SECURITY:  '/todays-visits',
  };

  // Define which routes ONLY specific roles can access
  // If a role is not in the allowed list → they get redirected to their home
  const routeAccessMap: Record<string, string[]> = {
    '/dashboard':            ['HOST'],
    '/users':                ['ADMIN'],
    '/host-users':           ['ADMIN'],
    '/visitors':             ['ADMIN'],
    '/blacklist-requests':   ['ADMIN'],
    '/roles-permissions':    ['ADMIN'],
    '/master-data':          ['ADMIN'],
    '/reports':              ['ADMIN', 'RECEPTION', 'SECURITY'],
    '/todays-visits':        ['RECEPTION', 'SECURITY'],
    '/visit-list':           ['HOST', 'ADMIN'],
    '/manage-visitors':      ['HOST', 'ADMIN'],
    '/location-wise-visitors': ['RECEPTION', 'SECURITY'],
    '/create-visit':         ['HOST'],
    '/create-visit-by-reception': ['RECEPTION', 'SECURITY'],
    '/approval-requests':    ['HOST', 'ADMIN'],
  };

  // Extract the base path, e.g. '/dashboard' from '/dashboard/something'
  const urlSegments = state.url.split('?')[0].split('/');
  const basePath = '/' + urlSegments[1];

  const allowedRoles = routeAccessMap[basePath];

  // If the route is in our map and the user's role is NOT allowed
  if (allowedRoles && !allowedRoles.includes(roleKey)) {
    const redirectTo = homeRoutes[roleKey] || '/settings';
    return router.createUrlTree([redirectTo], { replaceUrl: true } as any);
  }

  // Route not in map (e.g. public or unknown) → allow through
  return true;
};